/* eslint-disable */

export enum ArgoVerifyMaterialActionKind {
  ProcessCollect = 'process_collect',
  ProcessSolve = 'process_solve',
  WorkInstructionAssign = 'work_instruction_assign',
  WorkInstructionCollect = 'work_instruction_collect'
}

